import { createUseStyles } from "react-jss";

export default createUseStyles({
    footer: {
        composes: "paginated-table__footer",
        display: "flex",
        fontSize: "12px",
        flexDirection: "row",
        alignItems: "center",
        padding: [[12, 0]],
    },
    pageInfo: {
        composes: "paginated-table__page-info",
    },
    flex: {
        flex: 1,
    },
    rowsPerPage: {
        padding: [[0, 24]],
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
});
